"use client";

import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 md:gap-8">
        {[0, 1, 2].map(i => <div data-index={i} key={i} className="space-y-4">
            <div className="h-3 w-24 bg-foreground/10 animate-pulse rounded-md" />
            <div className="space-y-3">
              <div className="h-4 w-32 bg-foreground/10 animate-pulse rounded-md" />
              <div className="h-4 w-28 bg-foreground/10 animate-pulse rounded-md" />
              <div className="h-4 w-36 bg-foreground/10 animate-pulse rounded-md" />
            </div>
          </div>)}
      </div>;
  }
  const columns = [];
  return <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 md:gap-8">
      {columns.map((col, i) => <div data-index={i} key={col.eyebrow} className="space-y-5">
          <div className="space-y-4">
            <div className="h-px w-16 bg-slate-600/20" />
            <p className="font-default text-xs uppercase tracking-[0.16em] text-slate-600 font-bold">
              {col.eyebrow}
            </p>
          </div>
          <ul className="space-y-3.5">
            {col.links.map((link, j) => <li data-index={j} key={link.label}>
                <Link to={link.to} className="group relative inline-block text-[0.9375rem] text-slate-700 hover:text-slate-900 transition-colors duration-200">
                  <span>{link.label}</span>
                  <span className="absolute left-0 -bottom-0.5 h-px w-0 group-hover:w-full transition-all duration-[280ms] ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
              backgroundColor: "var(--ring)"
            }} />
                </Link>
              </li>)}
          </ul>
        </div>)}
    </div>;
}
export default function Footer() {
  const bottomLinks = [{
    label: "Privacy Policy",
    to: "#"
  }, {
    label: "Legal Notice",
    to: "#"
  }, {
    label: "Disclosures",
    to: "#"
  }];
  return;
}